import React from 'react';
import { useTranslation } from 'react-i18next';
import DataCollectionAdd from '../../shared/DataCollectionAdd.js';

const AddListCategoryForm = () => {
  const { t } = useTranslation();
  return (
    <>
      <input type="text" name="name" placeholder={t('category')} required />
    </>
  );
};

const getBodyFromForm = (formData) =>
  JSON.stringify({
    name: formData.get('name'),
  });

export const AddListCategory = ({ onSuccess }) => (
  <DataCollectionAdd
    collection="lists.categories"
    getBodyFromForm={getBodyFromForm}
    formElements={AddListCategoryForm}
    onSuccess={onSuccess}
  />
);

export default AddListCategory;
